import { TDeviceType } from '@cian/ui-kit';
import * as React from 'react';

import { VideoPlaybackModal } from '../../components/VideoPlaybackModal';
import { useApplicationContext } from '../../utils/applicationContext';

interface IVideoPlaybackModalContainerProps {
  isOpen: boolean;
  onClose: () => void;
  deviceType: TDeviceType;
}

export const VideoPlaybackModalContainer: React.FC<IVideoPlaybackModalContainerProps> = ({
  deviceType,
  isOpen,
  onClose,
}) => {
  const { config } = useApplicationContext();
  const infoVideoSrc = config.get<string>('info-broker-frontend.infoVideoLink') ?? '';
  const ref = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (isOpen) {
      ref.current?.focus();
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'initial';
    }
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  return (
    <VideoPlaybackModal
      isOpen={isOpen}
      deviceType={deviceType}
      modalRef={ref}
      onClose={onClose}
      videoSrc={infoVideoSrc}
    />
  );
};
